module.exports = __webpack_public_path__ + "img/125ne.a2ec9672.svg";